import { render } from "./detialsReservation.vue?vue&type=template&id=1ce48716&scoped=true"
import script from "./detialsReservation.vue?vue&type=script&lang=js"
export * from "./detialsReservation.vue?vue&type=script&lang=js"

import "./detialsReservation.vue?vue&type=style&index=0&id=1ce48716&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce48716"]])

export default __exports__